import {
  Checkbox,
  Button,
  FormControlLabel,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import * as XLSX from "xlsx";
import React, {useEffect, useState} from "react";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "material-react-table";
import { useGetRepoPrevDettByPrev } from "./Services";
import { download, generateCsv, mkConfig } from "export-to-csv";
import { RepoPrevDett } from "./types";

interface PreventiviExpProps {
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  globalFilter: string;
  sorting: MRT_SortingState;
  onClose: () => void;
  idprevtestaprop: number;
}

const PreventiviExp: React.FC<PreventiviExpProps> = ({
  pagination,
  columnFilters,
  globalFilter,
  sorting,
  onClose,
  idprevtestaprop,
}) => {
  const repoPrevDettFields = [
    "id",
    "codarea",
    "desarea",
    "codmodulo",
    "desmodulo",
    "numanalisi",
    "numconf",
    "numform",
    "numtot",
    "numprep",
    "note",
  ];

  const { data: { results = [] } = {} } = useGetRepoPrevDettByPrev(
    pagination,
    columnFilters,
    globalFilter,
    sorting,
    idprevtestaprop
  );

  const [selectedFields, setSelectedFields] = useState<string[]>(repoPrevDettFields);


  const handleFieldToggle = (field: string) => {
    setSelectedFields((prev) =>
      prev.includes(field)
        ? prev.filter((f) => f !== field)
        : [...prev, field]
    );
  };

  const generateExcelData = () =>
    results.map((repoPrevDett) => {
      const rowData: Record<string, any> = {};
      selectedFields.forEach((field) => {
        rowData[field] = repoPrevDett[field as keyof RepoPrevDett] ?? "";
      });
      return rowData;
    });

  const handleExportExcel = () => {
    const excelData = generateExcelData();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PreventivoExcel");
    XLSX.writeFile(workbook, "preventivo.xlsx");
  };

  const csvConfig = mkConfig({
    filename: "preventivo",
    fieldSeparator: ";",
    decimalSeparator: ",",
    useKeysAsHeaders: true,
    showColumnHeaders: true,
  });

  const handleExportCSV = () => {
    const selectedData = results.map((repoPrevDett) => {
      const rowData: Record<string, any> = {};
      selectedFields.forEach((field) => {
        rowData[field] = repoPrevDett[field as keyof RepoPrevDett] ?? "";
      });
      return rowData;
    });

    const csv = generateCsv(csvConfig)(selectedData);
    download(csvConfig)(csv);
  };

  const handleSelectAll = () => setSelectedFields(repoPrevDettFields);
  const handleDeSelectAll = () => setSelectedFields([]);
  const handleClose = () => onClose();

  return (
    <Dialog onClose={onClose} open fullWidth maxWidth="md">
      <DialogContent>
        <Typography variant="h6" gutterBottom>
          Seleziona Campi da esportare:
        </Typography>

        {/* Campo selezione */}
        <Stack
          direction="row"
          flexWrap="wrap"
          spacing={1}
          useFlexGap
          sx={{ mb: 2 }}
        >
          {repoPrevDettFields.map((field) => (
            <FormControlLabel
              key={field}
              control={
                <Checkbox
                  checked={selectedFields.includes(field)}
                  onChange={() => handleFieldToggle(field)}
                />
              }
              label={field}
            />
          ))}
        </Stack>

        {/* Pulsanti esportazione */}
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          flexWrap="wrap"
          useFlexGap
        >
          <Button
            color="primary"
            variant="outlined"
            onClick={handleSelectAll}
          >
            SELEZIONA TUTTI
          </Button>

          <Button
            color="primary"
            variant="outlined"
            onClick={handleDeSelectAll}
          >
            DESELEZ. TUTTI
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={handleExportCSV}
          >
            EXPORT TO CSV
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={handleExportExcel}
          >
            EXPORT TO EXCEL
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
          >
            CHIUDI
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PreventiviExp;
